import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_bath_shower: FaireCategoryEntity = {
  token: "cat_bath-shower",
  type: "category",
  name: "Shower curtains",
  level: 3,
  parentToken: "cat_home-decor-bath",
  href: "/category/home-decor/bath/shower-curtains",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
